{
  "defaultCategory": "Autre",
  "categories": {
    "domains": {
      "facebook.com": "Réseaux sociaux",
      "meta.com": "Réseaux sociaux",
      "instagram.com": "Réseaux sociaux",
      "twitter.com": "Réseaux sociaux",
      "x.com": "Réseaux sociaux",
      "snapchat.com": "Réseaux sociaux",
      "tiktok.com": "Réseaux sociaux",
      "pinterest.com": "Réseaux sociaux",
      "pinterest.fr": "Réseaux sociaux",
      "reddit.com": "Réseaux sociaux",
      "tumblr.com": "Réseaux sociaux",
      "discord.com": "Réseaux sociaux",
      "whatsapp.com": "Réseaux sociaux",
      "telegram.org": "Réseaux sociaux",
      "signal.org": "Réseaux sociaux",
      "bereal.com": "Réseaux sociaux",
      "threads.net": "Réseaux sociaux",
      "mastodon.social": "Réseaux sociaux",
      "bsky.app": "Réseaux sociaux",
      "vk.com": "Réseaux sociaux",
      "quora.com": "Réseaux sociaux",
      "netflix.com": "Streaming & divertissement",
      "disneyplus.com": "Streaming & divertissement",
      "primevideo.com": "Streaming & divertissement",
      "canalplus.com": "Streaming & divertissement",
      "canal-plus.com": "Streaming & divertissement",
      "mycanal.fr": "Streaming & divertissement",
      "molotov.tv": "Streaming & divertissement",
      "crunchyroll.com": "Streaming & divertissement",
      "twitch.tv": "Streaming & divertissement",
      "youtube.com": "Streaming & divertissement",
      "arte.tv": "Streaming & divertissement",
      "france.tv": "Streaming & divertissement",
      "tf1.fr": "Streaming & divertissement",
      "6play.fr": "Streaming & divertissement",
      "m6.fr": "Streaming & divertissement",
      "paramountplus.com": "Streaming & divertissement",
      "max.com": "Streaming & divertissement",
      "rakuten.tv": "Streaming & divertissement",
      "allocine.fr": "Streaming & divertissement",
      "imdb.com": "Streaming & divertissement",
      "letterboxd.com": "Streaming & divertissement",
      "ugc.fr": "Streaming & divertissement",
      "pathe.fr": "Streaming & divertissement",
      "spotify.com": "Musique",
      "deezer.com": "Musique",
      "soundcloud.com": "Musique",
      "tidal.com": "Musique",
      "bandcamp.com": "Musique",
      "shazam.com": "Musique",
      "last.fm": "Musique",
      "qobuz.com": "Musique",
      "radiofrance.fr": "Musique",
      "nrj.fr": "Musique",
      "steampowered.com": "Jeux vidéo",
      "steamcommunity.com": "Jeux vidéo",
      "epicgames.com": "Jeux vidéo",
      "ea.com": "Jeux vidéo",
      "battle.net": "Jeux vidéo",
      "blizzard.com": "Jeux vidéo",
      "ubisoft.com": "Jeux vidéo",
      "nintendo.com": "Jeux vidéo",
      "playstation.com": "Jeux vidéo",
      "xbox.com": "Jeux vidéo",
      "riotgames.com": "Jeux vidéo",
      "rockstargames.com": "Jeux vidéo",
      "gog.com": "Jeux vidéo",
      "itch.io": "Jeux vidéo",
      "roblox.com": "Jeux vidéo",
      "minecraft.net": "Jeux vidéo",
      "supercell.com": "Jeux vidéo",
      "humblebundle.com": "Jeux vidéo",
      "instant-gaming.com": "Jeux vidéo",
      "jeuxvideo.com": "Jeux vidéo",
      "amazon.com": "Shopping & e-commerce",
      "amazon.fr": "Shopping & e-commerce",
      "ebay.com": "Shopping & e-commerce",
      "ebay.fr": "Shopping & e-commerce",
      "etsy.com": "Shopping & e-commerce",
      "aliexpress.com": "Shopping & e-commerce",
      "wish.com": "Shopping & e-commerce",
      "shein.com": "Shopping & e-commerce",
      "temu.com": "Shopping & e-commerce",
      "vinted.fr": "Shopping & e-commerce",
      "vinted.com": "Shopping & e-commerce",
      "leboncoin.fr": "Shopping & e-commerce",
      "cdiscount.com": "Shopping & e-commerce",
      "fnac.com": "Shopping & e-commerce",
      "darty.com": "Shopping & e-commerce",
      "boulanger.com": "Shopping & e-commerce",
      "rueducommerce.fr": "Shopping & e-commerce",
      "backmarket.fr": "Shopping & e-commerce",
      "backmarket.com": "Shopping & e-commerce",
      "laredoute.fr": "Shopping & e-commerce",
      "veepee.fr": "Shopping & e-commerce",
      "showroomprive.com": "Shopping & e-commerce",
      "manomano.fr": "Shopping & e-commerce",
      "leroymerlin.fr": "Shopping & e-commerce",
      "castorama.fr": "Shopping & e-commerce",
      "bricodepot.fr": "Shopping & e-commerce",
      "ikea.com": "Shopping & e-commerce",
      "conforama.fr": "Shopping & e-commerce",
      "but.fr": "Shopping & e-commerce",
      "action.com": "Shopping & e-commerce",
      "lidl.fr": "Shopping & e-commerce",
      "carrefour.fr": "Shopping & e-commerce",
      "auchan.fr": "Shopping & e-commerce",
      "intermarche.com": "Shopping & e-commerce",
      "monoprix.fr": "Shopping & e-commerce",
      "franprix.fr": "Shopping & e-commerce",
      "picard.fr": "Shopping & e-commerce",
      "shopify.com": "Shopping & e-commerce",
      "wonderbox.fr": "Shopping & e-commerce",
      "smartbox.com": "Shopping & e-commerce",
      "zalando.fr": "Mode & beauté",
      "asos.com": "Mode & beauté",
      "zara.com": "Mode & beauté",
      "hm.com": "Mode & beauté",
      "uniqlo.com": "Mode & beauté",
      "nike.com": "Mode & beauté",
      "adidas.fr": "Mode & beauté",
      "sephora.fr": "Mode & beauté",
      "nocibe.fr": "Mode & beauté",
      "marionnaud.fr": "Mode & beauté",
      "yves-rocher.fr": "Mode & beauté",
      "kiabi.com": "Mode & beauté",
      "celio.com": "Mode & beauté",
      "jules.com": "Mode & beauté",
      "promod.fr": "Mode & beauté",
      "mango.com": "Mode & beauté",
      "bershka.com": "Mode & beauté",
      "pullandbear.com": "Mode & beauté",
      "stradivarius.com": "Mode & beauté",
      "footlocker.fr": "Mode & beauté",
      "courir.com": "Mode & beauté",
      "vestiairecollective.com": "Mode & beauté",
      "sarenza.com": "Mode & beauté",
      "spartoo.com": "Mode & beauté",
      "paypal.com": "Banque & finance",
      "revolut.com": "Banque & finance",
      "n26.com": "Banque & finance",
      "boursorama.com": "Banque & finance",
      "boursobank.com": "Banque & finance",
      "fortuneo.fr": "Banque & finance",
      "hellobank.fr": "Banque & finance",
      "ing.fr": "Banque & finance",
      "bnpparibas.com": "Banque & finance",
      "bnpparibas.net": "Banque & finance",
      "societegenerale.fr": "Banque & finance",
      "credit-agricole.fr": "Banque & finance",
      "lcl.fr": "Banque & finance",
      "caisse-epargne.fr": "Banque & finance",
      "banquepopulaire.fr": "Banque & finance",
      "creditmutuel.fr": "Banque & finance",
      "cic.fr": "Banque & finance",
      "labanquepostale.fr": "Banque & finance",
      "monabanq.com": "Banque & finance",
      "lydia-app.com": "Banque & finance",
      "sumup.com": "Banque & finance",
      "stripe.com": "Banque & finance",
      "wise.com": "Banque & finance",
      "qonto.com": "Banque & finance",
      "shine.fr": "Banque & finance",
      "cofidis.fr": "Banque & finance",
      "cetelem.fr": "Banque & finance",
      "oney.fr": "Banque & finance",
      "klarna.com": "Banque & finance",
      "alma.eu": "Banque & finance",
      "bankin.com": "Banque & finance",
      "younited-credit.com": "Banque & finance",
      "maif.fr": "Assurance & mutuelle",
      "macif.fr": "Assurance & mutuelle",
      "matmut.fr": "Assurance & mutuelle",
      "axa.fr": "Assurance & mutuelle",
      "allianz.fr": "Assurance & mutuelle",
      "groupama.fr": "Assurance & mutuelle",
      "gmf.fr": "Assurance & mutuelle",
      "maaf.fr": "Assurance & mutuelle",
      "harmonie-mutuelle.fr": "Assurance & mutuelle",
      "mgen.fr": "Assurance & mutuelle",
      "malakoffhumanis.com": "Assurance & mutuelle",
      "april.fr": "Assurance & mutuelle",
      "luko.eu": "Assurance & mutuelle",
      "direct-assurance.fr": "Assurance & mutuelle",
      "swisslife.fr": "Assurance & mutuelle",
      "generali.fr": "Assurance & mutuelle",
      "ag2rlamondiale.fr": "Assurance & mutuelle",
      "orange.fr": "Télécom & internet",
      "sosh.fr": "Télécom & internet",
      "sfr.fr": "Télécom & internet",
      "red-by-sfr.fr": "Télécom & internet",
      "bouyguestelecom.fr": "Télécom & internet",
      "free.fr": "Télécom & internet",
      "freemobile.fr": "Télécom & internet",
      "prixtel.com": "Télécom & internet",
      "lebara.fr": "Télécom & internet",
      "lycamobile.fr": "Télécom & internet",
      "ovh.com": "Télécom & internet",
      "ovhcloud.com": "Télécom & internet",
      "gandi.net": "Télécom & internet",
      "ionos.fr": "Télécom & internet",
      "hostinger.fr": "Télécom & internet",
      "o2switch.fr": "Télécom & internet",
      "nordvpn.com": "Télécom & internet",
      "expressvpn.com": "Télécom & internet",
      "edf.fr": "Énergie & factures",
      "engie.fr": "Énergie & factures",
      "totalenergies.fr": "Énergie & factures",
      "eni.com": "Énergie & factures",
      "vattenfall.fr": "Énergie & factures",
      "ekwateur.fr": "Énergie & factures",
      "mint-energie.com": "Énergie & factures",
      "enedis.fr": "Énergie & factures",
      "grdf.fr": "Énergie & factures",
      "veolia.fr": "Énergie & factures",
      "suez.fr": "Énergie & factures",
      "saur.com": "Énergie & factures",
      "booking.com": "Voyage & transport",
      "airbnb.com": "Voyage & transport",
      "airbnb.fr": "Voyage & transport",
      "uber.com": "Voyage & transport",
      "blablacar.fr": "Voyage & transport",
      "sncf-connect.com": "Voyage & transport",
      "sncf.com": "Voyage & transport",
      "oui.sncf": "Voyage & transport",
      "trainline.com": "Voyage & transport",
      "ratp.fr": "Voyage & transport",
      "flixbus.fr": "Voyage & transport",
      "ouigo.com": "Voyage & transport",
      "ryanair.com": "Voyage & transport",
      "easyjet.com": "Voyage & transport",
      "transavia.com": "Voyage & transport",
      "airfrance.fr": "Voyage & transport",
      "klm.com": "Voyage & transport",
      "lufthansa.com": "Voyage & transport",
      "expedia.fr": "Voyage & transport",
      "hotels.com": "Voyage & transport",
      "tripadvisor.fr": "Voyage & transport",
      "kayak.fr": "Voyage & transport",
      "skyscanner.fr": "Voyage & transport",
      "liligo.com": "Voyage & transport",
      "abritel.fr": "Voyage & transport",
      "gites-de-france.com": "Voyage & transport",
      "europcar.fr": "Voyage & transport",
      "hertz.fr": "Voyage & transport",
      "sixt.fr": "Voyage & transport",
      "getaround.com": "Voyage & transport",
      "vinci-autoroutes.com": "Voyage & transport",
      "sanef.com": "Voyage & transport",
      "ulys.com": "Voyage & transport",
      "iledefrance-mobilites.fr": "Voyage & transport",
      "omio.com": "Voyage & transport",
      "lastminute.com": "Voyage & transport",
      "bolt.eu": "Voyage & transport",
      "free-now.com": "Voyage & transport",
      "deliveroo.fr": "Livraison & restauration",
      "deliveroo.com": "Livraison & restauration",
      "ubereats.com": "Livraison & restauration",
      "just-eat.fr": "Livraison & restauration",
      "justeat.fr": "Livraison & restauration",
      "doordash.com": "Livraison & restauration",
      "frichti.co": "Livraison & restauration",
      "hellofresh.fr": "Livraison & restauration",
      "quitoque.fr": "Livraison & restauration",
      "mcdonalds.fr": "Livraison & restauration",
      "dominos.fr": "Livraison & restauration",
      "pizzahut.fr": "Livraison & restauration",
      "burgerking.fr": "Livraison & restauration",
      "kfc.fr": "Livraison & restauration",
      "subway.com": "Livraison & restauration",
      "starbucks.fr": "Livraison & restauration",
      "thefork.fr": "Livraison & restauration",
      "lafourchette.com": "Livraison & restauration",
      "sushishop.fr": "Livraison & restauration",
      "toogoodtogo.com": "Livraison & restauration",
      "laposte.fr": "Colis & courrier",
      "laposte.net": "Colis & courrier",
      "colissimo.fr": "Colis & courrier",
      "chronopost.fr": "Colis & courrier",
      "mondialrelay.fr": "Colis & courrier",
      "ups.com": "Colis & courrier",
      "dhl.com": "Colis & courrier",
      "fedex.com": "Colis & courrier",
      "gls-group.eu": "Colis & courrier",
      "dpd.fr": "Colis & courrier",
      "relaiscolis.com": "Colis & courrier",
      "google.com": "Outils & productivité",
      "gmail.com": "Outils & productivité",
      "microsoft.com": "Outils & productivité",
      "outlook.com": "Outils & productivité",
      "hotmail.com": "Outils & productivité",
      "live.com": "Outils & productivité",
      "office.com": "Outils & productivité",
      "apple.com": "Outils & productivité",
      "icloud.com": "Outils & productivité",
      "notion.so": "Outils & productivité",
      "slack.com": "Outils & productivité",
      "zoom.us": "Outils & productivité",
      "trello.com": "Outils & productivité",
      "asana.com": "Outils & productivité",
      "airtable.com": "Outils & productivité",
      "monday.com": "Outils & productivité",
      "clickup.com": "Outils & productivité",
      "figma.com": "Outils & productivité",
      "canva.com": "Outils & productivité",
      "dropbox.com": "Outils & productivité",
      "box.com": "Outils & productivité",
      "wetransfer.com": "Outils & productivité",
      "evernote.com": "Outils & productivité",
      "todoist.com": "Outils & productivité",
      "calendly.com": "Outils & productivité",
      "doodle.com": "Outils & productivité",
      "miro.com": "Outils & productivité",
      "zapier.com": "Outils & productivité",
      "mailchimp.com": "Outils & productivité",
      "brevo.com": "Outils & productivité",
      "sendinblue.com": "Outils & productivité",
      "wordpress.com": "Outils & productivité",
      "wix.com": "Outils & productivité",
      "squarespace.com": "Outils & productivité",
      "webflow.com": "Outils & productivité",
      "adobe.com": "Outils & productivité",
      "dashlane.com": "Outils & productivité",
      "1password.com": "Outils & productivité",
      "lastpass.com": "Outils & productivité",
      "bitwarden.com": "Outils & productivité",
      "proton.me": "Outils & productivité",
      "protonmail.com": "Outils & productivité",
      "mozilla.org": "Outils & productivité",
      "grammarly.com": "Outils & productivité",
      "deepl.com": "Outils & productivité",
      "openai.com": "Outils & productivité",
      "anthropic.com": "Outils & productivité",
      "claude.ai": "Outils & productivité",
      "perplexity.ai": "Outils & productivité",
      "midjourney.com": "Outils & productivité",
      "mistral.ai": "Outils & productivité",
      "github.com": "Développement & tech",
      "gitlab.com": "Développement & tech",
      "bitbucket.org": "Développement & tech",
      "stackoverflow.com": "Développement & tech",
      "npmjs.com": "Développement & tech",
      "docker.com": "Développement & tech",
      "vercel.com": "Développement & tech",
      "netlify.com": "Développement & tech",
      "heroku.com": "Développement & tech",
      "digitalocean.com": "Développement & tech",
      "amazonaws.com": "Développement & tech",
      "cloudflare.com": "Développement & tech",
      "mongodb.com": "Développement & tech",
      "supabase.com": "Développement & tech",
      "jetbrains.com": "Développement & tech",
      "replit.com": "Développement & tech",
      "codepen.io": "Développement & tech",
      "raspberrypi.com": "Développement & tech",
      "arduino.cc": "Développement & tech",
      "unity.com": "Développement & tech",
      "huggingface.co": "Développement & tech",
      "duolingo.com": "Éducation & formation",
      "coursera.org": "Éducation & formation",
      "udemy.com": "Éducation & formation",
      "khanacademy.org": "Éducation & formation",
      "openclassrooms.com": "Éducation & formation",
      "edx.org": "Éducation & formation",
      "datacamp.com": "Éducation & formation",
      "leetcode.com": "Éducation & formation",
      "parcoursup.fr": "Éducation & formation",
      "studyrama.com": "Éducation & formation",
      "letudiant.fr": "Éducation & formation",
      "campusfrance.org": "Éducation & formation",
      "cned.fr": "Éducation & formation",
      "cnam.fr": "Éducation & formation",
      "epitech.eu": "Éducation & formation",
      "42.fr": "Éducation & formation",
      "babbel.com": "Éducation & formation",
      "gymglish.com": "Éducation & formation",
      "busuu.com": "Éducation & formation",
      "scribbr.fr": "Éducation & formation",
      "studocu.com": "Éducation & formation",
      "quizlet.com": "Éducation & formation",
      "chegg.com": "Éducation & formation",
      "linkedin.com": "Emploi & réseau pro",
      "indeed.com": "Emploi & réseau pro",
      "indeed.fr": "Emploi & réseau pro",
      "glassdoor.com": "Emploi & réseau pro",
      "monster.fr": "Emploi & réseau pro",
      "welcometothejungle.com": "Emploi & réseau pro",
      "apec.fr": "Emploi & réseau pro",
      "pole-emploi.fr": "Emploi & réseau pro",
      "francetravail.fr": "Emploi & réseau pro",
      "hellowork.com": "Emploi & réseau pro",
      "cadremploi.fr": "Emploi & réseau pro",
      "jobteaser.com": "Emploi & réseau pro",
      "malt.fr": "Emploi & réseau pro",
      "upwork.com": "Emploi & réseau pro",
      "fiverr.com": "Emploi & réseau pro",
      "doctolib.fr": "Santé & bien-être",
      "ameli.fr": "Santé & bien-être",
      "maiia.com": "Santé & bien-être",
      "qare.fr": "Santé & bien-être",
      "livi.fr": "Santé & bien-être",
      "doctissimo.fr": "Santé & bien-être",
      "vidal.fr": "Santé & bien-être",
      "calm.com": "Santé & bien-être",
      "headspace.com": "Santé & bien-être",
      "withings.com": "Santé & bien-être",
      "alan.com": "Santé & bien-être",
      "strava.com": "Sport & fitness",
      "decathlon.fr": "Sport & fitness",
      "basic-fit.com": "Sport & fitness",
      "fitnesspark.fr": "Sport & fitness",
      "neoness.fr": "Sport & fitness",
      "keepcool.fr": "Sport & fitness",
      "garmin.com": "Sport & fitness",
      "fitbit.com": "Sport & fitness",
      "myfitnesspal.com": "Sport & fitness",
      "intersport.fr": "Sport & fitness",
      "go-sport.com": "Sport & fitness",
      "alltricks.fr": "Sport & fitness",
      "fff.fr": "Sport & fitness",
      "service-public.fr": "Administration & services publics",
      "impots.gouv.fr": "Administration & services publics",
      "caf.fr": "Administration & services publics",
      "urssaf.fr": "Administration & services publics",
      "ants.gouv.fr": "Administration & services publics",
      "interieur.gouv.fr": "Administration & services publics",
      "education.gouv.fr": "Administration & services publics",
      "amendes.gouv.fr": "Administration & services publics",
      "lemonde.fr": "Actualités & médias",
      "lefigaro.fr": "Actualités & médias",
      "liberation.fr": "Actualités & médias",
      "mediapart.fr": "Actualités & médias",
      "lesechos.fr": "Actualités & médias",
      "leparisien.fr": "Actualités & médias",
      "ouest-france.fr": "Actualités & médias",
      "20minutes.fr": "Actualités & médias",
      "francetvinfo.fr": "Actualités & médias",
      "bfmtv.com": "Actualités & médias",
      "rtl.fr": "Actualités & médias",
      "europe1.fr": "Actualités & médias",
      "courrierinternational.com": "Actualités & médias",
      "nytimes.com": "Actualités & médias",
      "theguardian.com": "Actualités & médias",
      "medium.com": "Actualités & médias",
      "substack.com": "Actualités & médias",
      "lequipe.fr": "Actualités & médias",
      "futura-sciences.com": "Actualités & médias",
      "numerama.com": "Actualités & médias",
      "frandroid.com": "Actualités & médias",
      "clubic.com": "Actualités & médias",
      "01net.com": "Actualités & médias",
      "seloger.com": "Immobilier & logement",
      "pap.fr": "Immobilier & logement",
      "logic-immo.com": "Immobilier & logement",
      "bienici.com": "Immobilier & logement",
      "orpi.com": "Immobilier & logement",
      "century21.fr": "Immobilier & logement",
      "foncia.com": "Immobilier & logement",
      "nexity.fr": "Immobilier & logement",
      "studapart.com": "Immobilier & logement",
      "actionlogement.fr": "Immobilier & logement",
      "garantme.fr": "Immobilier & logement",
      "visale.fr": "Immobilier & logement",
      "tinder.com": "Rencontres",
      "bumble.com": "Rencontres",
      "meetic.fr": "Rencontres",
      "happn.com": "Rencontres",
      "hinge.co": "Rencontres",
      "grindr.com": "Rencontres",
      "badoo.com": "Rencontres",
      "fruitz.io": "Rencontres",
      "adopteunmec.com": "Rencontres",
      "binance.com": "Crypto & investissement",
      "coinbase.com": "Crypto & investissement",
      "kraken.com": "Crypto & investissement",
      "ledger.com": "Crypto & investissement",
      "bitpanda.com": "Crypto & investissement",
      "crypto.com": "Crypto & investissement",
      "metamask.io": "Crypto & investissement",
      "etoro.com": "Crypto & investissement",
      "trade-republic.com": "Crypto & investissement",
      "degiro.fr": "Crypto & investissement",
      "fnacspectacles.com": "Billetterie & événements",
      "ticketmaster.fr": "Billetterie & événements",
      "eventbrite.fr": "Billetterie & événements",
      "eventbrite.com": "Billetterie & événements",
      "dice.fm": "Billetterie & événements",
      "shotgun.live": "Billetterie & événements",
      "weezevent.com": "Billetterie & événements",
      "meetup.com": "Billetterie & événements",
      "billetreduc.com": "Billetterie & événements",
      "francebillet.com": "Billetterie & événements",
      "helloasso.com": "Associations & dons",
      "unicef.fr": "Associations & dons",
      "croix-rouge.fr": "Associations & dons",
      "secourspopulaire.fr": "Associations & dons",
      "restosducoeur.org": "Associations & dons",
      "wwf.fr": "Associations & dons",
      "greenpeace.fr": "Associations & dons",
      "amnesty.fr": "Associations & dons",
      "leetchi.com": "Associations & dons",
      "gofundme.com": "Associations & dons",
      "kisskissbankbank.com": "Associations & dons",
      "ulule.com": "Associations & dons",
      "meethue.com": "Maison & objets connectés",
      "philips-hue.com": "Maison & objets connectés",
      "ismartlife.me": "Maison & objets connectés",
      "tuya.com": "Maison & objets connectés",
      "netatmo.com": "Maison & objets connectés",
      "somfy.fr": "Maison & objets connectés",
      "tp-link.com": "Maison & objets connectés",
      "ring.com": "Maison & objets connectés",
      "sonos.com": "Maison & objets connectés",
      "xiaomi.com": "Maison & objets connectés",
      "shelly.cloud": "Maison & objets connectés",
      "legrand.fr": "Maison & objets connectés",
      "geneanet.org": "Loisirs & culture",
      "filae.com": "Loisirs & culture",
      "ancestry.fr": "Loisirs & culture",
      "babelio.com": "Loisirs & culture",
      "senscritique.com": "Loisirs & culture",
      "flickr.com": "Loisirs & culture",
      "500px.com": "Loisirs & culture",
      "deviantart.com": "Loisirs & culture",
      "audible.fr": "Loisirs & culture",
      "kobo.com": "Loisirs & culture",
      "furet.com": "Loisirs & culture",
      "zooplus.fr": "Animaux",
      "wanimo.com": "Animaux",
      "croquetteland.com": "Animaux",
      "ece.fr": "Éducation & formation",
      "esilv.fr": "Éducation & formation",
      "devinci.fr": "Éducation & formation",
      "efrei.fr": "Éducation & formation",
      "esiee.fr": "Éducation & formation",
      "isep.fr": "Éducation & formation",
      "estaca.fr": "Éducation & formation",
      "junia.com": "Éducation & formation",
      "cy-tech.fr": "Éducation & formation",
      "utc.fr": "Éducation & formation",
      "insa-lyon.fr": "Éducation & formation",
      "ensam.eu": "Éducation & formation",
      "polytechnique.edu": "Éducation & formation",
      "centralesupelec.fr": "Éducation & formation",
      "sorbonne-universite.fr": "Éducation & formation",
      "dauphine.psl.eu": "Éducation & formation",
      "u-paris.fr": "Éducation & formation",
      "hec.fr": "Éducation & formation",
      "essec.edu": "Éducation & formation",
      "superprof.fr": "Éducation & formation",
      "acadomia.fr": "Éducation & formation",
      "wooclap.com": "Éducation & formation",
      "kahoot.com": "Éducation & formation",
      "biocoop.fr": "Shopping & e-commerce",
      "naturalia.fr": "Shopping & e-commerce",
      "grandfrais.com": "Shopping & e-commerce",
      "bricomarche.com": "Shopping & e-commerce",
      "gifi.fr": "Shopping & e-commerce",
      "temu.fr": "Shopping & e-commerce",
      "montecarlosbm.com": "Voyage & transport",
      "velib-metropole.fr": "Voyage & transport",
      "crazygames.com": "Jeux vidéo",
      "socgen.com": "Banque & finance",
      "massimodutti.com": "Mode & beauté",
      "pullbear.com": "Mode & beauté",
      "birkenstock.com": "Mode & beauté",
      "breguet.com": "Mode & beauté",
      "adidas.com": "Mode & beauté",
      "sephora.com": "Mode & beauté",
      "lacoste.com": "Mode & beauté",
      "snipes.com": "Mode & beauté",
      "sezane.com": "Mode & beauté",
      "levi.com": "Mode & beauté",
      "betclic.fr": "Paris & jeux d'argent",
      "betclic.com": "Paris & jeux d'argent",
      "winamax.fr": "Paris & jeux d'argent",
      "unibet.fr": "Paris & jeux d'argent",
      "pmu.fr": "Paris & jeux d'argent",
      "parionssport.fdj.fr": "Paris & jeux d'argent",
      "fdj.fr": "Paris & jeux d'argent",
      "stake.com": "Paris & jeux d'argent",
      "stake.us": "Paris & jeux d'argent",
      "zebet.fr": "Paris & jeux d'argent",
      "pokerstars.fr": "Paris & jeux d'argent",
      "pokerstars.com": "Paris & jeux d'argent",
      "bwin.fr": "Paris & jeux d'argent",
      "netbet.fr": "Paris & jeux d'argent",
      "groupebarriere.io": "Paris & jeux d'argent",
      "groupebarriere.com": "Paris & jeux d'argent",
      "casinosbarriere.com": "Paris & jeux d'argent",
      "blackjackapprenticeship.com": "Paris & jeux d'argent",
      "mpg.football": "Sport & fitness",
      "flyingblue.com": "Voyage & transport",
      "info-flyingblue.com": "Voyage & transport",
      "eurostar.com": "Voyage & transport",
      "eurail.com": "Voyage & transport",
      "interrail.eu": "Voyage & transport",
      "hostelworld.com": "Voyage & transport",
      "theclockinn.cz": "Voyage & transport",
      "previo.app": "Voyage & transport",
      "ridedott.com": "Voyage & transport",
      "lime.bike": "Voyage & transport",
      "li.me": "Voyage & transport",
      "heetch.com": "Voyage & transport",
      "freenow.com": "Voyage & transport",
      "flixbus.com": "Voyage & transport",
      "thetrainline.com": "Voyage & transport",
      "vueling.com": "Voyage & transport",
      "trivago.fr": "Voyage & transport",
      "accor.com": "Voyage & transport",
      "all.accor.com": "Voyage & transport",
      "marriott.com": "Voyage & transport",
      "discovereu.europa.eu": "Voyage & transport",
      "start-discover.eu": "Voyage & transport",
      "envoituresimone.com": "Éducation & formation",
      "stych.fr": "Éducation & formation",
      "ornikar.com": "Éducation & formation",
      "lepermislibre.fr": "Éducation & formation",
      "nosdevoirs.fr": "Éducation & formation",
      "jai20enmaths.com": "Éducation & formation",
      "commentairecompose.fr": "Éducation & formation",
      "numworks.com": "Éducation & formation",
      "scribzee.com": "Éducation & formation",
      "ratatype.com": "Éducation & formation",
      "omneseducation.com": "Éducation & formation",
      "concoursavenir.fr": "Éducation & formation",
      "concoursavenir.net": "Éducation & formation",
      "puissance-alpha.fr": "Éducation & formation",
      "getsolved.ai": "Éducation & formation",
      "izly.fr": "Éducation & formation",
      "etudiant.gouv.fr": "Éducation & formation",
      "messervices.etudiant.gouv.fr": "Éducation & formation",
      "kartable.fr": "Éducation & formation",
      "schoolmouv.fr": "Éducation & formation",
      "brainly.com": "Éducation & formation",
      "nomaplus.fr": "Éducation & formation",
      "dazn.com": "Streaming & divertissement",
      "francetv.fr": "Streaming & divertissement",
      "zeniptv.app": "Streaming & divertissement",
      "salto.fr": "Streaming & divertissement",
      "adn.fr": "Streaming & divertissement",
      "animationdigitalnetwork.fr": "Streaming & divertissement",
      "kick.com": "Streaming & divertissement",
      "geoguessr.com": "Jeux vidéo",
      "sony.com": "Jeux vidéo",
      "nianticlabs.com": "Jeux vidéo",
      "pokemon.com": "Jeux vidéo",
      "g2a.com": "Jeux vidéo",
      "chess.com": "Jeux vidéo",
      "lichess.org": "Jeux vidéo",
      "wiki-masters.com": "Loisirs & culture",
      "lefive.fr": "Sport & fitness",
      "equip.app": "Sport & fitness",
      "onefit.fr": "Sport & fitness",
      "urbansoccer.fr": "Sport & fitness",
      "playtomic.io": "Sport & fitness",
      "tricount.com": "Banque & finance",
      "link.com": "Banque & finance",
      "paybox.com": "Banque & finance",
      "sips-services.com": "Banque & finance",
      "worldline-solutions.com": "Banque & finance",
      "xoom.com": "Banque & finance",
      "sumeria.eu": "Banque & finance",
      "igraal.com": "Shopping & e-commerce",
      "myunidays.com": "Shopping & e-commerce",
      "unidays.com": "Shopping & e-commerce",
      "groupon.fr": "Shopping & e-commerce",
      "grouponmail.fr": "Shopping & e-commerce",
      "gumroad.com": "Shopping & e-commerce",
      "poulpeo.com": "Shopping & e-commerce",
      "myli.io": "Livraison & restauration",
      "robinhood.com": "Crypto & investissement",
      "traderepublic.com": "Crypto & investissement",
      "franklintempleton.com": "Crypto & investissement",
      "wyndlabs.ai": "Crypto & investissement",
      "grassfoundation.io": "Crypto & investissement",
      "getgrass.io": "Crypto & investissement",
      "deepseek.com": "Outils & productivité",
      "elevenlabs.io": "Outils & productivité",
      "goodnotes.com": "Outils & productivité",
      "prezi.com": "Outils & productivité",
      "autodesk.com": "Outils & productivité",
      "pngtree.com": "Outils & productivité",
      "screenpal.com": "Outils & productivité",
      "macked.app": "Outils & productivité",
      "codeweavers.com": "Développement & tech",
      "broadcom.com": "Développement & tech",
      "firebaseapp.com": "Développement & tech",
      "samsung.com": "Maison & objets connectés",
      "samsung-mail.com": "Maison & objets connectés",
      "facebookmail.com": "Réseaux sociaux",
      "passculture.app": "Loisirs & culture",
      "pass.culture.fr": "Loisirs & culture",
      "myheritage.com": "Loisirs & culture",
      "applicartevitale.fr": "Santé & bien-être",
      "youth.europa.eu": "Administration & services publics",
      "europa.eu": "Administration & services publics",
      "tribee.fr": "Associations & dons",
      "lepotcommun.fr": "Associations & dons",
      "trustpilotmail.com": "Shopping & e-commerce",
      "trustpilot.com": "Shopping & e-commerce",
      "agego.com": "Outils & productivité"
    },
    "rules": [
      {
        "endsWith": ".gouv.fr",
        "category": "Administration & services publics"
      },
      {
        "endsWith": ".gov",
        "category": "Administration & services publics"
      },
      {
        "contains": "service-public",
        "category": "Administration & services publics"
      },
      {
        "contains": "prefecture",
        "category": "Administration & services publics"
      },
      {
        "contains": "mairie",
        "category": "Administration & services publics"
      },
      {
        "contains": "urssaf",
        "category": "Administration & services publics"
      },
      {
        "contains": "impots",
        "category": "Administration & services publics"
      },
      {
        "contains": "assur",
        "category": "Assurance & mutuelle"
      },
      {
        "contains": "insur",
        "category": "Assurance & mutuelle"
      },
      {
        "contains": "mutuel",
        "category": "Assurance & mutuelle"
      },
      {
        "contains": "crypto",
        "category": "Crypto & investissement"
      },
      {
        "contains": "bitcoin",
        "category": "Crypto & investissement"
      },
      {
        "contains": "blockchain",
        "category": "Crypto & investissement"
      },
      {
        "contains": "banque",
        "category": "Banque & finance"
      },
      {
        "contains": "bank",
        "category": "Banque & finance"
      },
      {
        "contains": "credit",
        "category": "Banque & finance"
      },
      {
        "contains": "crédit",
        "category": "Banque & finance"
      },
      {
        "contains": "epargne",
        "category": "Banque & finance"
      },
      {
        "contains": "épargne",
        "category": "Banque & finance"
      },
      {
        "contains": "finance",
        "category": "Banque & finance"
      },
      {
        "contains": "paiement",
        "category": "Banque & finance"
      },
      {
        "contains": "payment",
        "category": "Banque & finance"
      },
      {
        "contains": "facture",
        "category": "Banque & finance"
      },
      {
        "contains": "doctolib",
        "category": "Santé & bien-être"
      },
      {
        "contains": "pharma",
        "category": "Santé & bien-être"
      },
      {
        "contains": "medic",
        "category": "Santé & bien-être"
      },
      {
        "contains": "médic",
        "category": "Santé & bien-être"
      },
      {
        "contains": "sante",
        "category": "Santé & bien-être"
      },
      {
        "contains": "santé",
        "category": "Santé & bien-être"
      },
      {
        "contains": "health",
        "category": "Santé & bien-être"
      },
      {
        "contains": "dentist",
        "category": "Santé & bien-être"
      },
      {
        "contains": "hopital",
        "category": "Santé & bien-être"
      },
      {
        "contains": "hôpital",
        "category": "Santé & bien-être"
      },
      {
        "contains": "clinique",
        "category": "Santé & bien-être"
      },
      {
        "contains": "opticien",
        "category": "Santé & bien-être"
      },
      {
        "contains": "fitness",
        "category": "Sport & fitness"
      },
      {
        "contains": "sport",
        "category": "Sport & fitness"
      },
      {
        "contains": "running",
        "category": "Sport & fitness"
      },
      {
        "contains": "muscu",
        "category": "Sport & fitness"
      },
      {
        "contains": "recrut",
        "category": "Emploi & réseau pro"
      },
      {
        "contains": "emploi",
        "category": "Emploi & réseau pro"
      },
      {
        "contains": "career",
        "category": "Emploi & réseau pro"
      },
      {
        "contains": "carriere",
        "category": "Emploi & réseau pro"
      },
      {
        "contains": "alternance",
        "category": "Emploi & réseau pro"
      },
      {
        "contains": "stage",
        "category": "Emploi & réseau pro"
      },
      {
        "contains": "jobs",
        "category": "Emploi & réseau pro"
      },
      {
        "contains": "talent",
        "category": "Emploi & réseau pro"
      },
      {
        "endsWith": ".edu",
        "category": "Éducation & formation"
      },
      {
        "startsWith": "univ-",
        "category": "Éducation & formation"
      },
      {
        "contains": "universit",
        "category": "Éducation & formation"
      },
      {
        "contains": "ecole",
        "category": "Éducation & formation"
      },
      {
        "contains": "école",
        "category": "Éducation & formation"
      },
      {
        "contains": "campus",
        "category": "Éducation & formation"
      },
      {
        "contains": "school",
        "category": "Éducation & formation"
      },
      {
        "contains": "academ",
        "category": "Éducation & formation"
      },
      {
        "contains": "formation",
        "category": "Éducation & formation"
      },
      {
        "contains": "etudiant",
        "category": "Éducation & formation"
      },
      {
        "contains": "étudiant",
        "category": "Éducation & formation"
      },
      {
        "contains": "scolaire",
        "category": "Éducation & formation"
      },
      {
        "contains": "learning",
        "category": "Éducation & formation"
      },
      {
        "contains": "moodle",
        "category": "Éducation & formation"
      },
      {
        "contains": "crous",
        "category": "Éducation & formation"
      },
      {
        "contains": "immo",
        "category": "Immobilier & logement"
      },
      {
        "contains": "logement",
        "category": "Immobilier & logement"
      },
      {
        "contains": "habitat",
        "category": "Immobilier & logement"
      },
      {
        "contains": "estate",
        "category": "Immobilier & logement"
      },
      {
        "contains": "energie",
        "category": "Énergie & factures"
      },
      {
        "contains": "énergie",
        "category": "Énergie & factures"
      },
      {
        "contains": "energy",
        "category": "Énergie & factures"
      },
      {
        "contains": "electric",
        "category": "Énergie & factures"
      },
      {
        "contains": "électric",
        "category": "Énergie & factures"
      },
      {
        "contains": "telecom",
        "category": "Télécom & internet"
      },
      {
        "contains": "télécom",
        "category": "Télécom & internet"
      },
      {
        "contains": "mobile",
        "category": "Télécom & internet"
      },
      {
        "contains": "fibre",
        "category": "Télécom & internet"
      },
      {
        "contains": "vpn",
        "category": "Télécom & internet"
      },
      {
        "contains": "hosting",
        "category": "Télécom & internet"
      },
      {
        "contains": "airlines",
        "category": "Voyage & transport"
      },
      {
        "contains": "airways",
        "category": "Voyage & transport"
      },
      {
        "startsWith": "air",
        "category": "Voyage & transport"
      },
      {
        "contains": "voyage",
        "category": "Voyage & transport"
      },
      {
        "contains": "travel",
        "category": "Voyage & transport"
      },
      {
        "contains": "hotel",
        "category": "Voyage & transport"
      },
      {
        "contains": "hôtel",
        "category": "Voyage & transport"
      },
      {
        "contains": "camping",
        "category": "Voyage & transport"
      },
      {
        "contains": "vacance",
        "category": "Voyage & transport"
      },
      {
        "contains": "train",
        "category": "Voyage & transport"
      },
      {
        "contains": "flight",
        "category": "Voyage & transport"
      },
      {
        "contains": "mobilites",
        "category": "Voyage & transport"
      },
      {
        "contains": "autoroute",
        "category": "Voyage & transport"
      },
      {
        "contains": "colis",
        "category": "Colis & courrier"
      },
      {
        "contains": "livraison",
        "category": "Colis & courrier"
      },
      {
        "contains": "delivery",
        "category": "Colis & courrier"
      },
      {
        "contains": "shipping",
        "category": "Colis & courrier"
      },
      {
        "contains": "restaurant",
        "category": "Livraison & restauration"
      },
      {
        "contains": "resto",
        "category": "Livraison & restauration"
      },
      {
        "contains": "pizza",
        "category": "Livraison & restauration"
      },
      {
        "contains": "burger",
        "category": "Livraison & restauration"
      },
      {
        "contains": "sushi",
        "category": "Livraison & restauration"
      },
      {
        "contains": "traiteur",
        "category": "Livraison & restauration"
      },
      {
        "contains": "food",
        "category": "Livraison & restauration"
      },
      {
        "contains": "eats",
        "category": "Livraison & restauration"
      },
      {
        "contains": "billet",
        "category": "Billetterie & événements"
      },
      {
        "contains": "ticket",
        "category": "Billetterie & événements"
      },
      {
        "contains": "event",
        "category": "Billetterie & événements"
      },
      {
        "contains": "spectacle",
        "category": "Billetterie & événements"
      },
      {
        "contains": "festival",
        "category": "Billetterie & événements"
      },
      {
        "contains": "concert",
        "category": "Billetterie & événements"
      },
      {
        "contains": "gaming",
        "category": "Jeux vidéo"
      },
      {
        "contains": "games",
        "category": "Jeux vidéo"
      },
      {
        "contains": "jeux",
        "category": "Jeux vidéo"
      },
      {
        "contains": "esport",
        "category": "Jeux vidéo"
      },
      {
        "contains": "music",
        "category": "Musique"
      },
      {
        "contains": "musique",
        "category": "Musique"
      },
      {
        "contains": "radio",
        "category": "Musique"
      },
      {
        "contains": "podcast",
        "category": "Musique"
      },
      {
        "endsWith": ".tv",
        "category": "Streaming & divertissement"
      },
      {
        "contains": "stream",
        "category": "Streaming & divertissement"
      },
      {
        "contains": "cinema",
        "category": "Streaming & divertissement"
      },
      {
        "contains": "cine",
        "category": "Streaming & divertissement"
      },
      {
        "contains": "video",
        "category": "Streaming & divertissement"
      },
      {
        "contains": "replay",
        "category": "Streaming & divertissement"
      },
      {
        "contains": "beaut",
        "category": "Mode & beauté"
      },
      {
        "contains": "cosmet",
        "category": "Mode & beauté"
      },
      {
        "contains": "parfum",
        "category": "Mode & beauté"
      },
      {
        "contains": "coiffure",
        "category": "Mode & beauté"
      },
      {
        "contains": "fashion",
        "category": "Mode & beauté"
      },
      {
        "contains": "chaussur",
        "category": "Mode & beauté"
      },
      {
        "contains": "lingerie",
        "category": "Mode & beauté"
      },
      {
        "contains": "boutique",
        "category": "Shopping & e-commerce"
      },
      {
        "contains": "shopping",
        "category": "Shopping & e-commerce"
      },
      {
        "contains": "shop",
        "category": "Shopping & e-commerce"
      },
      {
        "contains": "store",
        "category": "Shopping & e-commerce"
      },
      {
        "contains": "market",
        "category": "Shopping & e-commerce"
      },
      {
        "contains": "achat",
        "category": "Shopping & e-commerce"
      },
      {
        "contains": "promo",
        "category": "Shopping & e-commerce"
      },
      {
        "contains": "soldes",
        "category": "Shopping & e-commerce"
      },
      {
        "contains": "discount",
        "category": "Shopping & e-commerce"
      },
      {
        "contains": "asso",
        "category": "Associations & dons"
      },
      {
        "contains": "fondation",
        "category": "Associations & dons"
      },
      {
        "contains": "donation",
        "category": "Associations & dons"
      },
      {
        "contains": "charit",
        "category": "Associations & dons"
      },
      {
        "contains": "presse",
        "category": "Actualités & médias"
      },
      {
        "contains": "journal",
        "category": "Actualités & médias"
      },
      {
        "contains": "news",
        "category": "Actualités & médias"
      },
      {
        "contains": "magazine",
        "category": "Actualités & médias"
      },
      {
        "contains": "media",
        "category": "Actualités & médias"
      },
      {
        "contains": "github",
        "category": "Développement & tech"
      },
      {
        "contains": "gitlab",
        "category": "Développement & tech"
      },
      {
        "contains": "cloud",
        "category": "Développement & tech"
      },
      {
        "contains": "developer",
        "category": "Développement & tech"
      },
      {
        "contains": "software",
        "category": "Développement & tech"
      },
      {
        "contains": "digital",
        "category": "Développement & tech"
      },
      {
        "contains": "genealog",
        "category": "Loisirs & culture"
      },
      {
        "contains": "musee",
        "category": "Loisirs & culture"
      },
      {
        "contains": "musée",
        "category": "Loisirs & culture"
      },
      {
        "contains": "biblioth",
        "category": "Loisirs & culture"
      },
      {
        "contains": "theatre",
        "category": "Loisirs & culture"
      },
      {
        "contains": "théâtre",
        "category": "Loisirs & culture"
      },
      {
        "contains": "photo",
        "category": "Loisirs & culture"
      },
      {
        "contains": "librairie",
        "category": "Loisirs & culture"
      },
      {
        "contains": "domotique",
        "category": "Maison & objets connectés"
      },
      {
        "contains": "smartlife",
        "category": "Maison & objets connectés"
      },
      {
        "contains": "smarthome",
        "category": "Maison & objets connectés"
      },
      {
        "contains": "bricol",
        "category": "Maison & objets connectés"
      },
      {
        "contains": "jardin",
        "category": "Maison & objets connectés"
      },
      {
        "contains": "veterinaire",
        "category": "Animaux"
      },
      {
        "contains": "vétérinaire",
        "category": "Animaux"
      },
      {
        "contains": "animalerie",
        "category": "Animaux"
      },
      {
        "contains": "pizz",
        "category": "Livraison & restauration"
      },
      {
        "contains": "kebab",
        "category": "Livraison & restauration"
      },
      {
        "contains": "brasserie",
        "category": "Livraison & restauration"
      },
      {
        "contains": "boulangerie",
        "category": "Livraison & restauration"
      },
      {
        "contains": "cafe-",
        "category": "Livraison & restauration"
      },
      {
        "contains": "lycee",
        "category": "Éducation & formation"
      },
      {
        "contains": "lycée",
        "category": "Éducation & formation"
      },
      {
        "contains": "college",
        "category": "Éducation & formation"
      },
      {
        "contains": "collège",
        "category": "Éducation & formation"
      },
      {
        "contains": "insa-",
        "category": "Éducation & formation"
      },
      {
        "contains": "soutien-scolaire",
        "category": "Éducation & formation"
      },
      {
        "contains": "tutorat",
        "category": "Éducation & formation"
      }
    ],
    "motsDomaine": {
      "Paris & jeux d'argent": [
        "bet",
        "casino",
        "poker",
        "turf",
        "loto",
        "lotto",
        "blackjack",
        "roulette",
        "jackpot"
      ],
      "Voyage & transport": [
        "travel",
        "voyage",
        "hotel",
        "hostel",
        "airline",
        "airways",
        "flight",
        "flights",
        "trip",
        "camping",
        "ferry",
        "taxi",
        "vtc",
        "booking",
        "rail",
        "train",
        "scooter",
        "mobilite",
        "mobility"
      ],
      "Éducation & formation": [
        "edu",
        "school",
        "ecole",
        "academy",
        "academie",
        "cours",
        "learn",
        "campus",
        "univ",
        "college",
        "lycee",
        "devoirs",
        "maths",
        "formation",
        "etudiant",
        "student",
        "tutor",
        "concours",
        "permis",
        "revision"
      ],
      "Jeux vidéo": [
        "game",
        "games",
        "gaming",
        "esport",
        "playstation",
        "xbox",
        "nintendo"
      ],
      "Crypto & investissement": [
        "crypto",
        "coin",
        "chain",
        "token",
        "defi",
        "nft",
        "airdrop",
        "web3",
        "invest",
        "broker",
        "trade",
        "trading",
        "bourse"
      ],
      "Banque & finance": [
        "pay",
        "wallet",
        "money",
        "cash",
        "fintech",
        "banq",
        "bank"
      ],
      "Sport & fitness": [
        "sport",
        "sports",
        "foot",
        "football",
        "fitness",
        "gym",
        "running",
        "velo",
        "tennis",
        "padel",
        "yoga",
        "soccer",
        "basket",
        "rugby"
      ],
      "Streaming & divertissement": [
        "tv",
        "stream",
        "iptv",
        "video",
        "film",
        "films",
        "movie",
        "movies",
        "cinema",
        "anime",
        "series"
      ],
      "Musique": [
        "music",
        "musique",
        "radio",
        "sound",
        "beats",
        "vinyl"
      ],
      "Santé & bien-être": [
        "sante",
        "health",
        "medic",
        "pharma",
        "clinic",
        "dental",
        "dentiste",
        "vitale",
        "therapy"
      ],
      "Emploi & réseau pro": [
        "job",
        "jobs",
        "emploi",
        "career",
        "careers",
        "carriere",
        "recrut",
        "talent",
        "hiring",
        "interim",
        "alternance"
      ],
      "Livraison & restauration": [
        "food",
        "eat",
        "resto",
        "restaurant",
        "pizza",
        "burger",
        "sushi",
        "kebab",
        "cafe",
        "coffee",
        "bakery"
      ],
      "Colis & courrier": [
        "colis",
        "parcel",
        "courrier",
        "relais",
        "dhl",
        "fedex",
        "ups",
        "gls",
        "chronopost"
      ],
      "Actualités & médias": [
        "news",
        "journal",
        "magazine",
        "presse",
        "actu",
        "gazette",
        "quotidien"
      ],
      "Mode & beauté": [
        "fashion",
        "mode",
        "beauty",
        "beaute",
        "cosmetic",
        "cosmetique",
        "parfum",
        "perfume",
        "wear",
        "apparel",
        "shoes",
        "chaussure",
        "sneaker",
        "sneakers",
        "bijou",
        "jewel"
      ],
      "Shopping & e-commerce": [
        "shop",
        "store",
        "boutique",
        "market",
        "deals",
        "promo",
        "outlet",
        "cashback",
        "achat",
        "solde",
        "soldes"
      ],
      "Associations & dons": [
        "asso",
        "association",
        "dons",
        "solidar",
        "fondation",
        "foundation",
        "charity",
        "cagnotte",
        "ong"
      ],
      "Billetterie & événements": [
        "ticket",
        "tickets",
        "billetterie",
        "event",
        "events",
        "festival",
        "concert",
        "spectacle"
      ],
      "Immobilier & logement": [
        "immo",
        "immobilier",
        "logement",
        "habitat",
        "appart",
        "rent",
        "loyer",
        "coloc"
      ],
      "Rencontres": [
        "dating",
        "rencontre",
        "love",
        "tinder",
        "meetic"
      ],
      "Télécom & internet": [
        "telecom",
        "fibre",
        "mobile",
        "esim",
        "vpn"
      ],
      "Énergie & factures": [
        "energie",
        "energy",
        "electric",
        "electricite",
        "gaz",
        "solar",
        "solaire"
      ],
      "Développement & tech": [
        "dev",
        "code",
        "git",
        "api",
        "hosting",
        "labs",
        "tech",
        "software",
        "firebase"
      ],
      "Outils & productivité": [
        "ai",
        "ia",
        "tool",
        "tools",
        "notes",
        "docs",
        "pdf",
        "design",
        "workspace"
      ],
      "Loisirs & culture": [
        "culture",
        "musee",
        "museum",
        "livre",
        "livres",
        "lecture",
        "theatre",
        "loisir",
        "loisirs",
        "wiki",
        "quiz",
        "genealog",
        "heritage"
      ],
      "Administration & services publics": [
        "gouv",
        "gov",
        "europa",
        "mairie",
        "prefecture",
        "caf"
      ]
    },
    "motsObjet": {
      "Paris & jeux d'argent": [
        "paris sportif",
        "pari gratuit",
        "freebet",
        "casino",
        "poker",
        "cote boostee",
        "bonus de bienvenue",
        "jackpot",
        "mise remboursee"
      ],
      "Voyage & transport": [
        "e-billet",
        "e-billets",
        "carte d'embarquement",
        "boarding pass",
        "votre vol",
        "your flight",
        "votre voyage",
        "your trip",
        "votre sejour",
        "check-in",
        "checkin",
        "reservation confirmee",
        "booking confirmation",
        "itineraire",
        "votre trajet",
        "billet de train"
      ],
      "Éducation & formation": [
        "formation",
        "lecon",
        "lecons",
        "devoirs",
        "eleve",
        "etudiant",
        "examen",
        "concours",
        "universite",
        "campus",
        "crous",
        "parcoursup",
        "pedagog",
        "revision",
        "classe virtuelle",
        "ton cours",
        "votre cours",
        "cours en ligne"
      ],
      "Livraison & restauration": [
        "votre repas",
        "commande de repas",
        "livreur",
        "restaurant",
        "reservation de table",
        "votre table"
      ],
      "Colis & courrier": [
        "votre colis",
        "suivi de colis",
        "point relais",
        "tracking number",
        "numero de suivi",
        "colis livre"
      ],
      "Shopping & e-commerce": [
        "votre commande",
        "your order",
        "suivi de la commande",
        "confirmation de commande",
        "ticket d'achat",
        "merci pour votre achat",
        "order confirmation",
        "shipped"
      ],
      "Banque & finance": [
        "virement",
        "prelevement",
        "carte bancaire",
        "releve de compte",
        "iban",
        "remboursement",
        "your card was declined",
        "paiement refuse",
        "payment confirmation",
        "confirmation de paiement",
        "brokerage"
      ],
      "Crypto & investissement": [
        "airdrop",
        "nft",
        "staking",
        "crypto",
        "blockchain",
        "portefeuille d'investissement",
        "trading"
      ],
      "Sport & fitness": [
        "entrainement",
        "seance",
        "match",
        "tournoi",
        "championnat",
        "prono",
        "coach sportif",
        "salle de sport"
      ],
      "Streaming & divertissement": [
        "est live",
        "en direct",
        "nouvel episode",
        "nouvelle saison",
        "regarder maintenant",
        "streaming",
        "bande-annonce"
      ],
      "Jeux vidéo": [
        "joueur",
        "player",
        "battle pass",
        "skins",
        "pokemon",
        "jeu video"
      ],
      "Santé & bien-être": [
        "rendez-vous medical",
        "ordonnance",
        "teleconsultation",
        "medecin",
        "pharmacie",
        "carte vitale",
        "mutuelle"
      ],
      "Emploi & réseau pro": [
        "candidature",
        "offre d'emploi",
        "recrutement",
        "entretien d'embauche",
        "alternance",
        "job"
      ],
      "Immobilier & logement": [
        "logement",
        "loyer",
        "appartement",
        "colocation",
        "quittance"
      ],
      "Associations & dons": [
        "cagnotte",
        "dons",
        "adhesion",
        "benevole",
        "recu fiscal",
        "association"
      ],
      "Billetterie & événements": [
        "e-ticket",
        "vos billets",
        "votre billet",
        "concert",
        "festival",
        "spectacle",
        "evenement"
      ],
      "Actualités & médias": [
        "a la une",
        "edition du jour",
        "l'essentiel de l'actu",
        "revue de presse",
        "editorial"
      ],
      "Réseaux sociaux": [
        "vous a mentionne",
        "nouvel abonne",
        "new follower",
        "a commente",
        "a aime votre",
        "demande d'ami",
        "friend request"
      ],
      "Outils & productivité": [
        "espace de travail",
        "workspace",
        "essai gratuit",
        "free trial",
        "document partage",
        "votre projet"
      ]
    }
  },
  "deletionLinks": {
    "google.com": "https://myaccount.google.com/deleteaccount",
    "gmail.com": "https://myaccount.google.com/deleteaccount",
    "facebook.com": "https://www.facebook.com/help/delete_account",
    "meta.com": "https://www.facebook.com/help/delete_account",
    "instagram.com": "https://www.instagram.com/accounts/remove/request/permanent/",
    "twitter.com": "https://twitter.com/settings/deactivate",
    "x.com": "https://twitter.com/settings/deactivate",
    "linkedin.com": "https://www.linkedin.com/psettings/account-management/closing-account",
    "netflix.com": "https://www.netflix.com/cancelplan",
    "amazon.com": "https://www.amazon.com/gp/css/account/info/close-account.html",
    "amazon.fr": "https://www.amazon.fr/gp/css/account/info/close-account.html",
    "spotify.com": "https://support.spotify.com/article/close-account/",
    "github.com": "https://github.com/settings/admin",
    "gitlab.com": "https://gitlab.com/-/profile/account",
    "dropbox.com": "https://www.dropbox.com/account/delete",
    "paypal.com": "https://www.paypal.com/myaccount/close/",
    "ebay.com": "https://www.ebay.com/help/account/closing-account",
    "reddit.com": "https://www.reddit.com/settings/account",
    "pinterest.com": "https://help.pinterest.com/en/article/deactivate-or-close-your-account",
    "snapchat.com": "https://accounts.snapchat.com/accounts/delete_account",
    "tiktok.com": "https://www.tiktok.com/setting/delete-account",
    "discord.com": "https://support.discord.com/hc/en-us/articles/212500837",
    "twitch.tv": "https://www.twitch.tv/settings/security",
    "apple.com": "https://privacy.apple.com/",
    "icloud.com": "https://privacy.apple.com/",
    "microsoft.com": "https://account.microsoft.com/account/closeaccount",
    "outlook.com": "https://account.microsoft.com/account/closeaccount",
    "hotmail.com": "https://account.microsoft.com/account/closeaccount",
    "live.com": "https://account.microsoft.com/account/closeaccount",
    "yahoo.com": "https://login.yahoo.com/account/delete",
    "adobe.com": "https://account.adobe.com/",
    "canva.com": "https://www.canva.com/help/delete-account/",
    "notion.so": "https://www.notion.so/help/delete-your-account",
    "slack.com": "https://slack.com/help/articles/204967239",
    "zoom.us": "https://support.zoom.us/hc/en-us/articles/201363243",
    "uber.com": "https://help.uber.com/riders/article/how-do-i-delete-my-account",
    "airbnb.com": "https://www.airbnb.com/help/article/995",
    "booking.com": "https://www.booking.com/content/contact-us.html",
    "deliveroo.fr": "https://deliveroo.co.uk/dpo",
    "steamcommunity.com": "https://help.steampowered.com/en/wizard/HelpWithMyAccount",
    "steampowered.com": "https://help.steampowered.com/en/wizard/HelpWithMyAccount",
    "epicgames.com": "https://www.epicgames.com/help/en-US/epic-accounts-c74/i-want-to-delete-my-account-a3399",
    "ea.com": "https://help.ea.com/en/help/account/close-or-deactivate-ea-account/",
    "battle.net": "https://battle.net/support/article/closing-a-blizzard-account",
    "quora.com": "https://www.quora.com/settings",
    "medium.com": "https://help.medium.com/hc/en-us/articles/214883265",
    "tumblr.com": "https://www.tumblr.com/settings/account",
    "wordpress.com": "https://wordpress.com/help/contact",
    "wix.com": "https://support.wix.com/en/article/deleting-your-wix-account",
    "shopify.com": "https://help.shopify.com/",
    "etsy.com": "https://www.etsy.com/your/account/close-shop/deactivate",
    "aliexpress.com": "https://sale.aliexpress.com/",
    "vinted.fr": "https://www.vinted.fr/help/60",
    "leboncoin.fr": "https://www.leboncoin.fr/aide",
    "blablacar.fr": "https://help.blablacar.fr/",
    "deezer.com": "https://www.deezer.com/account/close",
    "soundcloud.com": "https://help.soundcloud.com/hc/en-us/articles/115003569727",
    "whatsapp.com": "https://faq.whatsapp.com/1142481586460421",
    "telegram.org": "https://telegram.org/faq#q-how-do-i-delete-my-account",
    "duolingo.com": "https://support.duolingo.com/hc/en-us/articles/360033352332",
    "coursera.org": "https://learner.coursera.help/hc/en-us",
    "udemy.com": "https://support.udemy.com/hc/en-us/articles/229603868",
    "indeed.com": "https://secure.indeed.com/account/delete",
    "glassdoor.com": "https://www.glassdoor.com/member/account/settings",
    "airtable.com": "https://support.airtable.com/docs/deleting-your-airtable-account",
    "trello.com": "https://trello.com/my/account",
    "figma.com": "https://help.figma.com/hc/en-us/articles/360040328493",
    "canva.com.br": "https://www.canva.com/help/delete-account/",
    "booking.com.fr": "https://www.booking.com/content/contact-us.html"
  },
  "logoAliases": {
    "redditmail.com": "reddit.com",
    "service-airfrance.com": "airfrance.fr",
    "info-flyingblue.com": "flyingblue.com",
    "acer-mail.com": "acer.com",
    "samsung-mail.com": "samsung.com",
    "socgen.com": "societegenerale.fr",
    "connect.sncf": "sncf.com",
    "monbillet.sncf": "sncf.com",
    "monidentifiant.sncf": "sncf.com",
    "sips-services.com": "worldline.com",
    "worldline-solutions.com": "worldline.com",
    "concoursavenir.net": "concoursavenir.fr",
    "groupebarriere.io": "barriere.com",
    "sbm.mc": "montecarlosbm.com"
  },
  "brandAliases": {
    "connect.sncf": "sncf",
    "monbillet.sncf": "sncf",
    "monidentifiant.sncf": "sncf",
    "sncf-voyageurs.com": "sncf",
    "samsung-mail.com": "samsung",
    "socgen.com": "societegenerale",
    "redditmail.com": "reddit",
    "acer-mail.com": "acer",
    "service-airfrance.com": "airfrance",
    "info-flyingblue.com": "flyingblue",
    "worldline-solutions.com": "worldline",
    "sips-services.com": "worldline",
    "groupebarriere.io": "barriere",
    "concoursavenir.net": "concoursavenir",
    "sg.fr": "societegenerale",
    "notif-colissimo-laposte.info": "laposte",
    "notif-moncompte-laposte.info": "laposte",
    "news-montecarlosbm.com": "montecarlosbm",
    "sbm.mc": "montecarlosbm",
    "mail-crazygames.com": "crazygames",
    "bonjour-ratp.fr": "ratp",
    "velib-metropole.fr": "velib"
  },
  "brandNames": {
    "societegenerale": "Société Générale",
    "laposte": "La Poste",
    "montecarlosbm": "Monte-Carlo SBM",
    "iledefrance-mobilites": "Île-de-France Mobilités",
    "assurance-maladie": "Assurance Maladie",
    "service-public": "Service-Public",
    "service-civique": "Service Civique",
    "puissance-alpha": "Puissance Alpha",
    "concoursavenir": "Concours Avenir",
    "velib": "Vélib' Métropole",
    "ratp": "RATP",
    "sncf": "SNCF",
    "fdj": "FDJ",
    "dhl": "DHL",
    "cic": "CIC",
    "mpg": "MPG",
    "m6": "M6",
    "ece": "ECE",
    "crazygames": "CrazyGames",
    "epicgames": "Epic Games",
    "myunidays": "UNiDAYS",
    "openai": "OpenAI",
    "paypal": "PayPal",
    "dazn": "DAZN",
    "wix": "Wix",
    "x": "X"
  },
  "_lisezMoi": "Base de connaissances de l'outil. \"categories\" range chaque service dans une rubrique ; \"deletionLinks\" donne le lien direct vers la page de suppression de compte ; \"logoAliases\" indique la vraie marque derriere un domaine d'envoi sans site web (redditmail.com -> reddit.com) pour retrouver son logo ; \"brandAliases\" regroupe sous une meme marque des domaines qui ne se ressemblent pas (sg.fr et socgen.com -> societegenerale) ; \"brandNames\" donne le libelle affiche d'une marque (societegenerale -> Societe Generale). Tu peux completer ces listes a la main."
}
